import { atom } from 'jotai';
import type { MapBounds } from '../types';

export interface MapState {
  center: [number, number] | null;
  zoom: number;
  hasSetInitialLocation: boolean;
  shouldForceCenter?: boolean;
}

const defaultCenter: [number, number] = [18.533333, -72.333333]; // Haiti
const defaultZoom = 18;

export const mapStateAtom = atom<MapState>({
  center: null,
  zoom: 16,
  hasSetInitialLocation: false,
  shouldForceCenter: false
});

export const mapBoundsAtom = atom<MapBounds | null>(null);
export const isMapLoadingAtom = atom<boolean>(false);
export const hasUserInteractedWithMapAtom = atom<boolean>(false);

// Derived atom for map position
export const mapPositionAtom = atom(
  (get) => get(mapStateAtom),
  (get, set, newPosition: Partial<MapState>) => {
    const currentPosition = get(mapStateAtom);
    set(mapStateAtom, { ...currentPosition, ...newPosition });
  }
);